export function getStateXml(session?: string) {
    return (
        window['server'] && window['server'].getStateXml && window['server'].getStateXml(session)
    );
}

export function getCompressedData(json, rootTableName = 'NewDataSet') {
    return (
        window['server'] &&
        window['server'].getCompressedData &&
        window['server'].getCompressedData(json, rootTableName)
    );
}

export function getLocalizedTextServ(key) {
    return (
        window['server'] &&
        window['server']['getLocalizedText'] &&
        window['server']['getLocalizedText'](key)
    );
}
export function getLocalizedMoreInfoTextServ(key) {
    return (
        window['server'] &&
        window['server']['getLocalizedMoreInfoText'] &&
        window['server']['getLocalizedMoreInfoText'](key)
    );
}

export function gwtBuildServerCall(
    methodName,
    parameters,
    reason,
    isProcessServerAnswerGWT,
    callback,
    getConnectionHolder,
    processAsDataSet,
    showLoader
) {
    return (
        window['server'] &&
        window['server'].buildServerCall &&
        window['server'].buildServerCall(
            methodName,
            parameters,
            reason,
            isProcessServerAnswerGWT,
            callback,
            getConnectionHolder,
            processAsDataSet,
            showLoader
        )
    );
}
